export var breakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
export function up(b) {
  return "@media (min-width: ".concat(breakpoints[b], "px)");
}
export function down(b) {
  return "@media (max-width: ".concat(breakpoints[b] - 1, "px)");
}